import(/* webpackMode: "eager" */ "/app/apps/nsight-web/src/app/(public)/error.tsx");
